import { render, staticRenderFns } from "./OrdemDePagamentoView.vue?vue&type=template&id=da943f38&scoped=true"
import script from "./OrdemDePagamentoView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemDePagamentoView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrdemDePagamentoView.vue?vue&type=style&index=0&id=da943f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da943f38",
  null
  
)

export default component.exports